import script from "./verification-code.vue?vue&type=script&setup=true&lang=js"
export * from "./verification-code.vue?vue&type=script&setup=true&lang=js"

import "./verification-code.vue?vue&type=style&index=0&id=ee3cf12e&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/web-project4knfj/booltool-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee3cf12e"]])

export default __exports__